import React from 'react';
import { Fragment } from 'react';
import { fileUpload } from '../../../utils/request';
import Button from '../../form/Button';
import ImportButton from '../../form/ImportButton';
import Select from '../../form/Select';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Modal from '../../layout/Modal';
import Portal from '../../layout/Portal';
import {connect} from "src/store";
import {showModal} from "../../../actions";

class OptInSubscriberList extends React.Component {

    state = {
        importModal: false,
        importData: {
            optin: [],
            source: null
        }
    }

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    importFile = async (field, value) => {
        await this.props.processAction(async () => {
            try {
                const response = await fileUpload({
                    action: this.props.componentConfig.componentname + ".importComponents",
                    file: value,
                    ...this.state.importData
                });
                if (response.success) {
                    this.picklist && this.picklist.refreshBackground();
                    this.props.reloadForm && this.props.reloadForm();
                }
                if (response.msg) {
                    this.props.showModal({
                        size: "small",
                        theme: response.success ? "success" : "danger",
                        header: "",
                        text: response.msg,
                    });
                }
                return response;
            } catch (e) {
                console.error(e);
            }
        });
    }

    showUploadModal = () => {
        this.setState({importModal: true});
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "OptInSubscriberList"}
                reqparams={{showdeleted: true}}
                {...props}
                columns={{
                    "name": {header: "Feliratkozó neve", width: 1, filterable, sortable},
                    "email": {header: "Feliratkozó e-mail-címe", width: 1, filterable, sortable},
                    "active": {header: "Aktív feliratkozások", width: 1, filterable, sortable}
                }}
                orderBy={{field: "email", direction: "ASC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                groupBy={{by: "person_id", fields: {active: {type: "SUM"}}}}
                paginatorRight={(props) => <Fragment>
                    <Portal>
                        <Modal
                            state={this.state.importModal ? "on" : "off"}
                            theme="default"
                            size="medium"
                            header="Importálás"
                            onClose={() => {
                                this.setState({importModal: false});
                            }}
                        >
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <Select
                                            label="OptIn"
                                            name="optin"
                                            component="OptIn"
                                            objectValue={false}
                                            labelKey="name"
                                            required={true}
                                            valueKey="id"
                                            storeType="local"
                                            value={this.state.importData.optin || null}
                                            saveChanges={(field, value) => this.setState({importData: {...this.state.importData, optin: value}})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <Select
                                            label="Feliratkozás forrása"
                                            name="source"
                                            component="OptInSource"
                                            objectValue={false}
                                            labelKey="name"
                                            required={true}
                                            valueKey="id"
                                            storeType="local"
                                            value={this.state.importData.source || null}
                                            saveChanges={(field, value) => this.setState({importData: {...this.state.importData, source: value}})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <ImportButton
                                            {...this.props.getFieldProps("import")}
                                            data={this.props.values}
                                            disabled={!(this.state.importData.optin.length && this.state.importData.source)}
                                            componentConfig={this.props.componentConfig}
                                            label={<Fragment>&nbsp;</Fragment>}
                                            name="file"
                                            saveChanges={this.importFile}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </Portal>
                    <Button key="3" {...props} disabled={ this.props.isLoading } color="default" onClick={this.showUploadModal}>
                        Importálás
                    </Button>
                </Fragment>}
            />
        );
    }
}

export default connect(() => ({}),{showModal})(OptInSubscriberList);